import { AUTHOR, CETAGORY, SEARCH } from "./actionType";

export const filterCetagory = (text) => {
  return {
    type: CETAGORY,
    payload: text,
  };
};
export const filterAuthor = (authorid) => {
  return {
    type: AUTHOR,
    payload: authorid,
  };
};

export const searchInput = (text) => {
  return {
    type: SEARCH,
    payload: text,
  };
};
